<div class="position-relative">
  <webcam
    [height]="viewport.height"
    [trigger]="triggerObservable"
    (imageCapture)="handleImage($event)"
    *ngIf="showWebcam"
    [allowCameraSwitch]="allowCameraSwitch"
    [switchCamera]="nextWebcamObservable"
    [videoOptions]="videoOptions"
    (cameraSwitched)="cameraWasSwitched($event)"
    (initError)="handleInitError($event)"
  ></webcam>
  <div class="actionBtn">
    <div class="d-flex align-items-center justify-content-center">
      <button mat-icon-button (click)="triggerSnapshot()" title="Take Picture">
        <mat-icon> photo_camera </mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="showNextWebcam(true)"
        title="Switch Camera"
      >
        <mat-icon> cameraswitch </mat-icon>
      </button>
    </div>
  </div>
</div>
<h4 *ngIf="errors.length > 0">Messages:</h4>
<ul *ngFor="let error of errors">
  <li>{{ error | json }}</li>
</ul>
